import { useEffect, useState } from "react";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import Grid from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Fab,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
} from "@mui/material";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useLoading } from "../../../context/loading";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

const AddCandidate = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const jobId = searchParams.get("id"); // "JOB8767"

  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [disable, setdisable] = useState(false);

  const { setCirleLoading } = useLoading();
  const [Allsource, setAllsource] = useState([
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Indeed", label: "Indeed" },
    { value: "Company Website", label: "Company Website" },
    { value: "AngelList", label: "AngelList" },
    { value: "GitHub", label: "GitHub" },
    { value: "Upwork", label: "Upwork" },
    { value: "Stack Overflow Careers", label: "Stack Overflow Careers" },
    { value: "Xing", label: "Xing" },
    { value: "Recruitee", label: "Recruitee" },
    { value: "Hiretual", label: "Hiretual" },
    { value: "Monster", label: "Monster" },
    { value: "SimplyHired", label: "SimplyHired" },
    { value: "Toptal", label: "Toptal" },
    { value: "Jobvite", label: "Jobvite" },
    { value: "Workable", label: "Workable" },
    { value: "Recruitment Agency", label: "Recruitment Agency" },
    { value: "Employee referral", label: "Employee referral" },
  ]);

  const [update, setupdate] = useState(false);

  console.log(update, "updd");

  const [departments, setdepartments] = useState([]);

  console.log(departments, "alldepts");

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [filename, setfilename] = useState("");
  const [candidatedetails, setcandidatedetails] = useState({
    source: "",
    sourceStatus: "unchecked",
    // jobid: "",
    // jobidStatus: "unchecked",
    branch: "",
    branchStatus: "unchecked",
    mobileNumber: "",
    mobileNumberStatus: "unchecked",
    emailid: "",
    emailidStatus: "unchecked",
    department: "",
    departmentStatus: "unchecked",
    position: "",
    positionStatus: "unchecked",
    candidateName: "",
    candidateNameStatus: "unchecked",
    employeeAddress: "",
    employeeAddressStatus: "unchecked",
    officeAddress: "",
    officeAddressStatus: "unchecked",

    file: null,
    fileStatus: "unchecked",
  });

  console.log(candidatedetails, "taskkkdett");

  const fetchdataviajobid = async () => {
    try {
      const query = `
      query manuallyAddedCandidatesBasedonJobid($jobid: String!) {
  manuallyAddedCandidatesBasedonJobid(jobid: $jobid) {
    id
    jobid
    candidateName
    source
    branch  
    mobileNumber
    emailid
    cvFile
    department
    position
    screeningStatus
    manuallyAdd
    technicalFeedback {
      id
      hiringStatus
      manuallyAdd
      employeeAddress 
      officeAddress 
    }
  }
}
     
     `;
      const res = await axios.post(BASEURL, {
        query,
        variables: {
          jobid: jobId,
        },
      });
      console.log(
        res.data.data.manuallyAddedCandidatesBasedonJobid[0],
        "FETCHEDDATA"
      );
      const data = res.data.data.manuallyAddedCandidatesBasedonJobid[0];

      // console.log(
      //   departments?.find(
      //     (department) => department?.value === data?.department
      //   ),
      //   "dataaa"
      // );

      setcandidatedetails({
        id: data?.id,
        jobid: data?.jobid,
        jobidStatus: data?.jobid && "success",
        branch: data?.branch,
        branchStatus: data?.branch && "success",
        source: { value: data?.source, label: data?.source },
        sourceStatus: data?.source && "success",
        // department: { value: data?.department, label: data?.department },
        department: departments?.find(
          (department) => department?.label === data?.department
        ),

        departmentStatus: data?.department && "success",
        mobileNumber: data?.mobileNumber,
        mobileNumberStatus: data?.mobileNumber && "success",
        emailid: data?.emailid,
        emailidStatus: data?.emailid && "success",
        position: data?.position,
        positionStatus: data?.position && "success",
        candidateName: data?.candidateName,
        candidateNameStatus: data?.candidateName && "success",
        employeeAddress:data?.technicalFeedback?.length?data?.technicalFeedback?.[0]?.employeeAddress : null,
         employeeAddressStatus:data?.technicalFeedback?.length? data?.technicalFeedback?.[0].employeeAddress &&"success": null,
        officeAddress:data?.technicalFeedback?.length? data?.technicalFeedback[0].officeAddress:null,
        officeAddressStatus:data?.technicalFeedback?.length? data?.technicalFeedback[0].officeAddress && "success":null
        
      });
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    onDepartmentdata();
    // generateJobId();
    // if (jobId) {
    //    setTimeout(() => {
    //     fetchdataviajobid();
    //    }, 1000);

    // }
  }, []);
  useEffect(() => {
    if (departments.length > 0 && jobId) {
      fetchdataviajobid();
      setdisable(true);
    }
  }, [departments, jobId]);
  const generateJobId = () => {
    const prefix = "JOB"; // Prefix for Job ID
    const uniqueId = Date.now(); // Use timestamp as a unique identifier
    const randomSuffix = Math.floor(1000 + Math.random() * 9000); // 4-digit random number
    const newJobId = `${prefix}${randomSuffix}`;
    setcandidatedetails((prev) => ({
      ...prev,
      jobid: newJobId,
    }));
  };

  const onDepartmentdata = async () => {
    const query = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let departmentList = response.data.data.allDepartment;
      console.log(departmentList, "listt");

      departmentList = departmentList.map((department) => ({
        value: department?.id,
        // label: department?.departmentName + " " + department?.departmentCode,
        label: department?.departmentName,
      }));
      console.log(departmentList, "deptlistt");

      setdepartments(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const handlecandidatedetails = (feild, value) => {
    const updatedcandidatedetails = { ...candidatedetails };
    switch (feild) {
      case "source":
        if (value) {
          updatedcandidatedetails.sourceStatus = "success";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        }

        break;

      case "department":
        if (value) {
          updatedcandidatedetails.departmentStatus = "success";
        }

        break;

      case "position":
        if (value.length > 3 && value) {
          updatedcandidatedetails.positionStatus = "success";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        } else {
          updatedcandidatedetails.positionStatus = "error";
        }

        break;

      case "jobid":
        if (value.length > 3 && value) {
          updatedcandidatedetails.jobidStatus = "success";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        } else {
          updatedcandidatedetails.jobidStatus = "error";
        }

        break;
        
      case "branch": {
        const lengthRegex = /^[\s\S]{1,100}$/;

        console.log("value:", value);
        console.log("regex:", lengthRegex.test(value));

        if (!value) {
          updatedcandidatedetails.branchStatus = "unchecked";
        } else if (lengthRegex.test(value)) {
          updatedcandidatedetails.branchStatus = "success";
        } else {
          updatedcandidatedetails.branchStatus = "error";
        }

        break;
      };

      case "emailid":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailRegex.test(value)) {
          updatedcandidatedetails.emailidStatus = "success";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        } else {
          updatedcandidatedetails.emailidStatus = "error";
        }

        break;

      case "candidateName":
        if (value.length > 1 && value && value.length <= 100) {
          updatedcandidatedetails.candidateNameStatus = "success";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        } else {
          updatedcandidatedetails.candidateNameStatus = "error";
        }

        break;

      case "mobileNumber":
        console.log(value.length, "mobnum");

        if ((value.length < 10 && value) || (value.length > 10 && value)) {
          updatedcandidatedetails.mobileNumberStatus = "error";
        } else if (!value) {
          updatedcandidatedetails[feild + "Status"] = "unchecked";
        } else {
          updatedcandidatedetails.mobileNumberStatus = "success";
        }

        break;

      case "employeeAddress":
        console.log(value.length, "mobnum");

        if (value.length < 3 && value) {
          updatedcandidatedetails.employeeAddressStatus = "error";
        } else if (!value) {
          updatedcandidatedetails.employeeAddressStatus = "unchecked";
        } else {
          updatedcandidatedetails.employeeAddressStatus = "success";
        }

        break;

      case "officeAddress":
        console.log(value.length, "mobnum");

        if (value.length < 3 && value) {
          updatedcandidatedetails.officeAddressStatus = "error";
        } else if (!value) {
          updatedcandidatedetails.officeAddressStatus = "unchecked";
        } else {
          updatedcandidatedetails.officeAddressStatus = "success";
        }

        break;

      case "file":
        const file = value.target.files[0];
        console.log("filefile:", file.name);
        setfilename(file.name);
        updatedcandidatedetails[feild] = file;
        updatedcandidatedetails.fileStatus = "success";
    }
    if (feild != "file") {
      updatedcandidatedetails[feild] = value;
    }

    setcandidatedetails(updatedcandidatedetails);
  };

  //validation

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      candidatedetails.sourceStatus === "success" &&
      //   candidatedetails.departmentStatus === "success" &&
      candidatedetails.candidateNameStatus === "success" &&
      candidatedetails.mobileNumberStatus === "success" &&
      candidatedetails.emailidStatus === "success" &&
      candidatedetails.positionStatus === "success" &&
      candidatedetails.employeeAddressStatus === "success" &&
      candidatedetails.officeAddressStatus === "success" 
      // candidatedetails.jobidStatus==="success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const onAddcandidate = async () => {
    setCirleLoading(true);
    const query = `mutation CreateCandidate($input: CreateCandidateInput!) {
  createCandidate(input: $input) {
    sourcingScreening {
      id
      candidateName
      jobid      
    }
    technicalFeedback {
      id
      hiringStatus
    }
  }
}`;

    const update = `
mutation UpdateCandidateManually($input: UpdateCandidateInput!) {
  updateCandidate(input: $input) {
    sourcingScreening {
      id
      candidateName
      jobid      
    }
    technicalFeedback {
      id
      hiringStatus
    }

  }
}
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: jobId ? update : query,
          variables: {
            input: {
              // jobid: candidatedetails.jobid,
              branch: candidatedetails?.branch,
              candidateName: candidatedetails.candidateName,
              source: candidatedetails.source?.value,
              mobileNumber: candidatedetails.mobileNumber,
              emailid: candidatedetails.emailid,
              cvFile: candidatedetails.file,
              department: candidatedetails.department?.label,
              position: candidatedetails.position,
              employeeAddress: candidatedetails.employeeAddress,
              officeAddress: candidatedetails.officeAddress,
            },
          },
        }),
      });

      if (!jobId) {
        let result = response.data.data.createCandidate;
        if (result !== null) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Candidate Added Successfully",
            showConfirmButton: false,
            timer: 2500,
          });

          navigate("/recruitment/manually-added-candidate");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Can't able to Add Candidate",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else {
        let result = response.data.data.updateCandidate;
        if (result !== null) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Candidate Updated Successfully",
            showConfirmButton: false,
            timer: 2500,
          });

          navigate("/recruitment/manually-added-candidate");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Can't able to Update Candidate",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      }

      // console.log(
      //   "responsedata:",
      //   response.data.data.addleaveApproval?.leaveApproval
      // );
    } catch (error) {
      console.error("responseError:", error.response);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const DeleteCandidate = async () => {
    setCirleLoading(true);
    const query = `
mutation deleteCandidate($jobid: String!){
  deleteCandidate(jobid: $jobid){
    success
    message
  }
}
  
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: query,
          variables: {
            jobid: jobId,
          },
        }),
      });

      let result = response.data.data.deleteCandidate.success;
      let message = response.data.data.deleteCandidate.message;
      if (result !== null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });

        navigate("/recruitment/manually-added-candidate");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);

      // console.log(
      //   "responsedata:",
      //   response.data.data.addleaveApproval?.leaveApproval
      // );
    } catch (error) {
      console.error("responseError:", error.response);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  const handleCancel = () => {
    navigate("/recruitment/manually-added-candidate");
  };

  const handleAddcandidate = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: jobId
        ? "Are you sure you want to update your details?"
        : "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onAddcandidate();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleDeletecandidate = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to delete",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        DeleteCandidate();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const handleEditData = () => {
    setupdate(true);
    setdisable(false);
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              padding={1}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: "100%" }}
                spacing={60}
              >
                {jobId ? (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Candidate
                  </MaterialTypography>
                ) : (
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Candidate
                  </MaterialTypography>
                )}

                {jobId && (
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleEditData}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>

                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDeletecandidate}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton>
                  </ButtonGroup>
                )}
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              {/* candidate */}

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Candidate Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="estimated Hours"
                  value={candidatedetails.candidateName}
                  onChange={(e) =>
                    handlecandidatedetails("candidateName", e.target.value)
                  }
                  error={
                    candidatedetails.candidateNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    candidatedetails.candidateNameStatus === "success"
                      ? true
                      : false
                  }
                  disabled={disable}
                />
              </Grid>
              {/* source */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Source <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  //   placeholder="Auto generated"

                  options={Allsource}
                  value={candidatedetails.source}
                  onChange={(e) => handlecandidatedetails("source", e)}
                  success={candidatedetails?.sourceStatus == "success"}
                  error={candidatedetails?.sourceStatus == "error"}
                  isDisabled={disable}
                />
              </Grid>

              {/* Jobid */}
              {/* <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    JobId <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="JobId"
                  value={candidatedetails.jobid}
                  // disabled
                  onChange={(e) =>
                    handlecandidatedetails("jobid", e.target.value)
                  }
                  error={
                    candidatedetails.jobidStatus === "error" ? true : false
                  }
                  success={
                    candidatedetails.jobidStatus === "success" ? true : false
                  }
                  disabled={jobId?true:false}
                />
              </Grid> */}

              {/* Branch */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Branch
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="branch"
                  value={candidatedetails.branch}
                  // disabled
                  onChange={(e) =>
                    handlecandidatedetails("branch", e.target.value)
                  }
                  error={
                    candidatedetails.branchStatus === "error" ? true : false
                  }
                  success={
                    candidatedetails.branchStatus === "success" ? true : false
                  }
                  disabled={jobId?true:false}
                />
              </Grid>

              {/* mobile number */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Mobile Number<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="mobileNumber"
                  type="number"
                  value={candidatedetails.mobileNumber}
                  onChange={(e) =>
                    handlecandidatedetails("mobileNumber", e.target.value)
                  }
                  error={
                    candidatedetails.mobileNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    candidatedetails.mobileNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={disable}
                />
              </Grid>

              {/* email */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Email <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="emailid"
                  value={candidatedetails.emailid}
                  onChange={(e) =>
                    handlecandidatedetails("emailid", e.target.value)
                  }
                  error={
                    candidatedetails.emailidStatus === "error" ? true : false
                  }
                  success={
                    candidatedetails.emailidStatus === "success" ? true : false
                  }
                  disabled={disable}
                />
              </Grid>

              {/* position */}

              {/* mobile number */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Position <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="position"
                  value={candidatedetails.position}
                  onChange={(e) =>
                    handlecandidatedetails("position", e.target.value)
                  }
                  error={
                    candidatedetails.positionStatus === "error" ? true : false
                  }
                  success={
                    candidatedetails.positionStatus === "success" ? true : false
                  }
                  disabled={disable}
                />
              </Grid>

              {/*Department */}

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="Department"
                  //   placeholder="Auto generated"
                  isDisabled={disable}
                  options={departments}
                  value={candidatedetails.department}
                  onChange={(e) => handlecandidatedetails("department", e)}
                  success={candidatedetails?.departmentStatus == "success"}
                  error={candidatedetails?.departmentStatus == "error"}
                />
              </Grid>

              {/* Addresses */}

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  multiline
                  rows={4}
                  value={candidatedetails.employeeAddress}
                  onChange={(e) =>
                    handlecandidatedetails("employeeAddress", e.target.value)
                  }
                  error={
                    candidatedetails.employeeAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    candidatedetails.employeeAddressStatus === "success"
                      ? true
                      : false
                  }
                  disabled={disable}
                />
              </Grid>

              <Grid size={{ xs: 6, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Office Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="reason"
                  multiline
                  rows={4}
                  value={candidatedetails.officeAddress}
                  onChange={(e) =>
                    handlecandidatedetails("officeAddress", e.target.value)
                  }
                  error={
                    candidatedetails.officeAddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    candidatedetails.officeAddressStatus === "success"
                      ? true
                      : false
                  }
                  disabled={disable}
                />
              </Grid>

              {/* estimated Hours */}

              {/* <Grid
                //   mt={Finalresult[0]?.halfDayAllowed == false ? -8 : 0}
                size={{ xs: 5, sm: 4 }}
              >
                <MaterialBox lineHeight={0} display="inline-block" mb={1}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Upload the Document <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <Box
                  component="label"
                  htmlFor="upload-file"
                  sx={{
                    border: "2px dashed #90caf9",
                    borderRadius: "12px",
                    padding: "21px 43px",
                    width: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#f5faff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  }}
                >
                  <CloudUploadIcon sx={{ fontSize: 50, color: "#2196f3" }} />
                  <Typography sx={{ mt: 1, color: "#2196f3", fontWeight: 500 }}>
                    Browse file to upload
                  </Typography>
                  <input
                    hidden
                    id="upload-file"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handlecandidatedetails("file", e)}
                  />
                </Box>

                {candidatedetails?.fileStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please upload a valid document (PDF, JPG, PNG).
                    </FormHelperText>
                  </FormControl>
                )}

                <FormHelperText>{filename}</FormHelperText>
              </Grid> */}
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {update ? (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddcandidate}
              >
                Update
              </MaterialButton>
            </>
          ) : (
            !jobId && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleCancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddcandidate}
                >
                  Submit
                </MaterialButton>
              </>
            )
          )}

          {/* {display && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={LeaveEditRequest}
              >
                Update
              </MaterialButton>
            </>
          )} */}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default AddCandidate;
